module.exports = "<div class=\"footer\">\n  <p style=\"display: inline;\">Managed by <a href=\"http://4id.cl\" target=\"_blank\">4ID © Congress</a></p>\n</div>"